import axios from 'axios';

export const getImportant = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}/important/get-important`);
        return response.data;
    } catch (error) {
        console.error('Error fetching important info:', error);
        return { ok: false, data: null };
    }
};
